<template>
	<nav class="breadcrumb fixed">
		<span v-for="(crumb, index) in crumbs" :key="crumb.path" class="breadcrumb-item">
			<a v-if="index !== crumbs.length - 1" href="javascript:;" @click="navigateTo(crumb.path)">
				{{ crumb.title }}
			</a>
			<span v-else>{{ crumb.title }}</span>
			<span v-if="index !== crumbs.length - 1"> / </span>
		</span>
	</nav>
</template>

<script>
	export default {
		name: "Breadcrumb",
		data() {
			return {
				routeNameMap: {
					LandingPage: "首页",
					HomePage: "问卷模板",
					CreatePage: "创建问卷",
					MyPage: "我的问卷",
					DataStatisticsPage: "数据统计",
					RecyclePage: "回收站"
				},
			};
		},
		computed: {
		  crumbs() {
		    const isHomeRoute =
		      this.$route.name === "HomePage" ||
		      this.$route.path === "/home" ||
		      this.$route.path === "/";
		
		    const homeCrumb = {
		      path: "/home",
		      title: isHomeRoute ? "问卷模板" : "首页",
		    };
		
		    if (isHomeRoute) {
		      return [homeCrumb];
		    }
		
		    return [
		      homeCrumb,
		      {
		        path: this.$route.path,
		        title: this.routeNameMap[this.$route.name] || this.$route.name,
		      },
		    ];
		  },
		},
		methods: {
			navigateTo(path) {
				this.$router.push(path);
			},
		},
	};
</script>

<style scoped>
	.breadcrumb {
		padding: 10px 0;
		font-size: 14px;
	}

	.breadcrumb-item a {
		color: #409eff;
		cursor: pointer;
		text-decoration: none;
	}

	.breadcrumb-item a:hover {
		text-decoration: underline;
	}

	.breadcrumb span {
		color: #409eff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue